







import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroRoles } from "@/services/jinro-roles";
import LeftTimer from "@/components//JinroPlayer/LeftTimer.vue";
import Jinro from "@/components/JinroPlayer/Night/NightEachRoles/Jinro.vue";
import Uranaishi from "@/components/JinroPlayer/Night/NightEachRoles/Uranaishi.vue";
import Karyudo from "@/components/JinroPlayer/Night/NightEachRoles/Karyudo.vue";
import { JinroGamePlayinfoDocument } from "../../../services/datatypes";
@Component({
  components: {
    LeftTimer,
    Jinro,
    Uranaishi,
    Karyudo,
  },
})
export default class Night extends Vue {
  @Prop() readonly jinroPlayinfo!: JinroGamePlayinfoDocument;

  get jinroGameId(): string {
    if (this.$store.state.jinroGame) {
      return this.$store.state.jinroGame.id;
    }

    return "";
  }

  get playerRole(): string {
    if (this.$store.state.jinroPlayerGame) {
      return this.$store.state.jinroPlayerGame.role;
    }

    return "";
  }

  get componentPlayerRole(): string {
    if (this.playerRole === JinroRoles.Jinro) {
      return "jinro";
    }
    if (this.playerRole === JinroRoles.Uranaishi) {
      return "uranaishi";
    }
    if (this.playerRole === JinroRoles.Karyudo) {
      return "karyudo";
    }

    return "";
  }
}
